(() => {
  if (window.customFanCartInstalled) return;
  window.customFanCartInstalled = true;
  let busy = false;

  function messages(row) {
    const control = row.querySelector('[data-custom-fan-remove-priority]');
    return {
      confirm: control?.dataset.confirm,
      error: control?.dataset.error,
      changed: control?.dataset.changed,
      status: row.querySelector('[data-custom-fan-cart-status]'),
    };
  }

  async function removePriority(row, input) {
    if (busy) return;
    const text = messages(row);
    if (!text.confirm || !window.confirm(text.confirm)) {
      if (input) input.value = input.defaultValue;
      return;
    }
    busy = true;
    const button = row.querySelector('[data-custom-fan-remove-priority]');
    if (button) button.disabled = true;
    const root = window.Shopify?.routes?.root || '/';
    let committed = false;
    try {
      const response = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      const reference = row.dataset.customFanDesign;
      const updates = {};
      for (const item of cart.items) {
        if (item.properties?._custom_fan_design === reference && item.properties?._custom_fan_fee === 'rush') {
          updates[item.key] = 0;
        }
      }
      if (!Object.keys(updates).length) {
        window.location.reload();
        return;
      }
      const sections = ['main-cart-items', 'main-cart-footer', 'cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
      const update = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
      });
      const state = await update.json();
      if (!update.ok || state.errors || state.status) throw new Error('update');
      committed = true;
      if (!state.sections) {
        window.location.reload();
        return;
      }
      const parser = new DOMParser();
      const page = state.sections['main-cart-items'];
      if (page) {
        const current = document.querySelector('cart-items');
        const incoming = parser.parseFromString(page, 'text/html').querySelector('cart-items');
        if (current && incoming) {
          current.innerHTML = incoming.innerHTML;
          current.classList.toggle('is-empty', state.item_count === 0);
        }
      }
      for (const id of ['main-cart-footer', 'cart-icon-bubble', 'cart-live-region-text']) {
        const current = document.getElementById(id);
        const html = state.sections[id];
        if (!current || !html) continue;
        const doc = parser.parseFromString(html, 'text/html');
        const incoming = doc.getElementById(id) || doc.querySelector('.shopify-section');
        if (incoming) current.innerHTML = incoming.innerHTML;
      }
      const footer = document.getElementById('main-cart-footer');
      if (footer) footer.classList.toggle('is-empty', state.item_count === 0);
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.toggle('is-empty', state.item_count === 0);
        if (drawer.classList.contains('active') && state.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        }
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-fan-priority', cartData: state });
      }
    } catch {
      if (text.status) text.status.textContent = committed ? text.changed : text.error;
      if (input && !committed) input.value = input.defaultValue;
    } finally {
      busy = false;
      if (button?.isConnected) button.disabled = false;
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('[data-custom-fan-remove-priority], cart-remove-button')) return;
    const row = target.closest('[data-custom-fan-fee="rush"][data-custom-fan-design]');
    if (!row?.dataset.customFanDesign) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void removePriority(row);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'updates[]' || Number(input.value) !== 0) return;
    const row = input.closest('[data-custom-fan-fee="rush"][data-custom-fan-design]');
    if (!row?.dataset.customFanDesign) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void removePriority(row, input);
  }, true);
})();
